import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TranslateModule } from '@ngx-translate/core';
import { NouisliderModule } from 'ng2-nouislider';

import { InvoicesRoutingModule } from './invoices-routing.module';
import { InvoicesComponent } from './invoices/invoices.component';
import { InvoicesService } from 'app/shared/services/invoices.service';

import { UploadComponent } from './upload/upload.component';
import { DetailComponent } from './detail/detail.component';

import { CustomerService } from 'app/shared/services/customer.service';
import { ExpressPayService } from 'app/shared/services/expresspay.service';
import { InvoicesListModule } from "app/shared/invoices-list/invoices-list.module";
import {InvoiceResolver} from "../../resolver/invoice.resolver";
import { Ng2CompleterModule } from 'ng2-completer';
import { InvoiceSmallCardComponent } from './invoice-small-card/invoice-small-card.component';

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        InvoicesRoutingModule,
        FileUploadModule,
        PdfViewerModule,
        TranslateModule,
        NouisliderModule,
        InvoicesListModule,
        Ng2CompleterModule,
    ],
    declarations: [
        InvoicesComponent,
        UploadComponent,
        DetailComponent,
        InvoiceSmallCardComponent
    ],
    providers: [
        CustomerService,
        InvoicesService,
        ExpressPayService,
        InvoiceResolver
    ]
})

export class InvoicesModule { }



// WEBPACK FOOTER //
// /app/src/app/client/invoices/invoices.module.ts